import React from "react";
import { FaTrash } from "react-icons/fa";
import ContentMedia from "./ContentSection/ContentMedia";
import ContentEditor from "./ContentSection/ContentEditor";

export default function ContentSection({
  formData,
  errors,
  handleEditorChange,
  handleImageChange,
  handleAltTextChange,
  handleAddContent,
  handleDeleteContent,
}) {
  return (
    <div className="mb-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        Blog Content
      </h2>

      {formData.Content.map((content, index) => (
        <div
          key={index}
          className="mb-8 border rounded-lg p-6 shadow-sm bg-gray-50 relative"
        >
          {/* Delete Icon */}
          {formData.Content.length > 1 && (
            <button
              type="button"
              onClick={() => handleDeleteContent(index)}
              className="
                absolute top-1 right-1
                flex items-center justify-center
                w-9 h-9
                rounded-full
                text-gray-400
                hover:text-gray-600
                hover:bg-gray-100
                focus:outline-none focus:ring-2 focus:ring-gray-300
              "
              aria-label="Delete Content"
            >
              <FaTrash size={14} />
            </button>
          )}

          <h3 className="font-semibold text-xl border-b pb-2 mb-4">
            Content {index + 1}
          </h3>

          <ContentEditor
            value={content.html}
            index={index}
            onChange={handleEditorChange}
          />

          <ContentMedia
            image={content.img}
            altText={content.altText}
            index={index}
            onImageChange={handleImageChange}
            onAltTextChange={handleAltTextChange}
            error={errors[`ContentAltText_${index}`]}
          />
        </div>
      ))}

      <button
        type="button"
        onClick={handleAddContent}
        className="mt-4 bg-indigo-600 text-white px-6 py-3 rounded-lg shadow hover:bg-indigo-700 transition"
      >
        Add More Content
      </button>
    </div>
  );
}
